// Site Designations are a way to identify which of the white label instances are running.
// Locale, site links, company info are all derived by it.

export const SiteDesignations = Object.freeze({
  LTN_NA: 'ltn-na',
  STOCKLOADS_AUSTRALIA: 'stockloads-australia',
  CENTRAL_VALLEY: 'central-valley',
});



// WEBPACK FOOTER //
// ./src/siteDesignations.js